import React from 'react';
import {useGetCompEventListQuery, useListPilotRegistrationsQuery} from "../slices/apiSlice";
import Box from "@mui/material/Box";
import CompetitionCard from "../pages/Competition/CompetitionCard";
import {Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import {setEvent} from "../slices/sessionSlice";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";

const PilotEventRegistrationList = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {data: events, isSuccess: hasEvents} =
        useGetCompEventListQuery({compType:3})
    const {data: registrations, isSuccess: hasRegistrations} =
        useListPilotRegistrationsQuery()

    const selectEvent = (event) => {
        dispatch(setEvent(event))
        navigate('/event')
    }

    return (
        <Stack spacing={2} textAlign={'center'}>
            {hasRegistrations && hasEvents && registrations.length>0 &&
                registrations.map( entry => {
                    const event = events.find( e => e.id === entry.j)
                    return <Box key={entry.j}><CompetitionCard comp={event} registrationStatus={entry.u} onClick={()=>{selectEvent(event)}}/></Box>
                })
            }
            { hasRegistrations && hasEvents && registrations.length === 0 &&
                <Box sx={{background:'#eeeeee',p:'1em'}}>
                    <Typography variant={'body2'} my={2} sx={{fontStyle:'italic'}}>No event registrations</Typography>
                </Box>
            }
        </Stack>
    );
};

export default PilotEventRegistrationList;